import { render, staticRenderFns } from "./EmailAction.vue?vue&type=template&id=5110d70f&"
import script from "./EmailAction.vue?vue&type=script&lang=ts&"
export * from "./EmailAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports